<template>
  <div style='width: 100%'>

    <div id='playbar'>
      <div class="detailBox">
        <div class="flexAlinCenters">
          <div class="flexAlinCenter justifyCenter">
            <div class="headBox">
              <img src="../../assets/headImg.png" />
            </div>
            <div class="headText">农业云门户</div>
          </div>
          <div class="detailObj">
            <!-- <div class="detailText">地址：公司地址公司地址公司地址公司地址</div>
            <div class="detailText">邮编：100101</div>
            <div class="detailText">电话：123456789</div> -->
          </div>
        </div>

        <div class="codeBox">
          <div>
            <img src="../../assets/code.jpg" class="codeImg" />
          </div>
          <div>扫码关注</div>

        </div>
      </div>
      <div class="copyrightBox">
        版权所有 ©农业云门户
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Playbar',
  data() {
    return {
      audio: [
        {

        }
      ],

    }
  },
  mounted() {

  },
}
</script>

<style scoped lang="less">

.flexAlinCenter {
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .detailObj{
    line-height: 26px;
    margin-top: 25px;
  }
  .codeBox{
    display: none;
  }
  .justifyCenter{
    justify-content: center;
  }
  .flexAlinCenters{
    display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 16px;

  }
  .headBox {
    border-radius: 6px 6px 6px 6px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 50px;
      height: 50px;
    }
  }
  .headText {
font-weight: bold;
font-size: 24px;
color: #FFFFFF;
text-align: left;
font-style: normal;
text-transform: none;
    margin-left: 8px;
  }
}
@media (min-width: 769px) {
  .flexAlinCenters{
    display: flex;
  align-items: center;
  }
  .codeBox {
    margin-top: 26px;
    width: 72px;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    font-style: normal;
    text-transform: none;
    -webkit-text-stroke: 1px rgba(0, 0, 0, 0);
  }

  .detailBox {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
    
    height: 150px;
  }

  .detailText {
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 40px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .headText {
    font-weight: bold;
    font-size: 30px;
    color: #FFFFFF;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-left: 14px;
    margin-right: 50px;
  }

  .codeImg {
    width: 72px;
    height: 72px;
  }

  .headBox {
    border-radius: 6px 6px 6px 6px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 90px;
      height: 80px;
    }
  }
}

.copyrightBox {

  height: 50px;
  background: #00361F;
  border-radius: 0px 0px 0px 0px;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  font-style: normal;
  text-transform: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

#playbar {
  width: 100%;
  background-color: #003D23;
  // position: fixed;
  // bottom: 0;
  color: white;
  z-index: 99999;

}
</style>